<template>
  <div id="invoicingSet">
    <div class="commodityHead row">
      <el-button
        size="small"
        style="width: 100px"
        type="primary"
        @click="jumpTT('/invoicing/editSupplier')"
        >添加供应商</el-button
      >
      <div class="row" style="position: absolute; right: 20px">
        <el-input
          size="small"
          style="margin-left: 10px"
          placeholder="搜索名称/联系人/联系电话"
          v-model="value"
        ></el-input>
        <el-button size="small" style="margin-left: 20px" @click="search" type="primary"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="content">
      <!-- 表格 -->
      <div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            align="center"
            prop="supplierName"
            label="名称"
            width="180"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="supplierLink"
            label="联系人"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="supplierTel"
            label="联系电话"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="supplierClassificationName"
            label="分类"
          ></el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <!-- <template> -->
              <el-button
                class="button5"
                @click="detail(scope.row)"
                v-if="scope.row.supplierName !== '自采供应商'"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div v-if="tableData" class="block" style="float: right; margin-top: 10px">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pageVal"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="totalNumber"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { supplierList, supplierClassificationList, supplierListTotal } from "../api";
export default {
  data() {
    return {
      // 表格
      tableData: [],
      //排序下拉框数组
      options: [],
      value: "", //搜索框
      pageVal: 1, //分页页码
      totalNumber: null, //分页总条数
    };
  },
  created() {
    this.supplierList(); //供应商列表
  },
  methods: {
    //跳转
    jumpTT(adress, message) {
      // this.$router.push(adress)
      this.$router.push({ path: adress, query: { docId: message } });
    },
    //详情
    detail(arr) {
      console.log(arr);
      this.$router.push({
        path: "/invoicing/editSupplier",
        query: { type: "edit", supplierId: arr.supplierId },
      });
    },
    search() {
      this.pageVal = 1;
      console.log(this.value);
      this.supplierList(this.value.trim()); //供应商列表
    },
    //分页当前页
    handleCurrentChange(val) {
      this.pageVal = val;
      this.supplierList(); //供应商列表
    },
    //供应商列表
    supplierList(searchValue) {
      supplierList({
        synthesisSearch: searchValue,
        pageNo: this.pageVal,
        row: 10,
      })
        .then((res) => {
          if (res.code == 1) {
            this.tableData = res.data;
            console.log(this.tableData, "供应商列表");
          } else if (res.code == -1) {
            this.tableData = [];
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log("error");
        });
      supplierListTotal({
        synthesisSearch: searchValue,
      })
        .then((res) => {
          if (res.code == 1) {
            this.totalNumber = res.data.totalNum;
            console.log(this.tableData, "供应商列表条数");
          } else if (res.code == -1) {
            this.tableData = [];
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log("error");
        });
    },
    //供应商分类列表
    // supplierClassificationList(e) {
    //   supplierClassificationList({
    //   })
    //     .then(res => {
    //       if (res.code == 1) {
    //         this.options = res.data;
    //         console.log(this.options, "供应商分类列表");
    //       } else if (res.code == 2) {
    //         this.$message.error(res.msg);
    //         this.$router.push("/");
    //       } else {
    //         this.$message.error(res.msg);
    //       }
    //     })
    //     .catch(res => {
    //       console.log("error");
    //     });
    // }
  },
};
</script>
<style scoped>
.commodityHead {
  box-sizing: border-box;
  width: calc(100vw - 180px);
  padding: 15px 20px 15px 30px;
  background: #f8f8f8;
  height: 60px;
  position: fixed;
  z-index: 99;
}
.content {
  position: absolute;
  top: 110px;
  width: calc(100vw - 217px);
  box-sizing: border-box;
  padding: 25px;
}
.button5 {
  width: 45px;
  height: 30px;
  padding: 0;
  color: #409eff;
  border: 1px solid #409eff;
}
.row {
  display: flex;
}
</style>
